// Pages a client is restricted to. When a client_id is listed here the user can
// only reach the paths in its list; every other route redirects to the client's
// landing page and every other sidebar entry is hidden.
const RESTRICTED_CLIENT_PAGES = {
  1438: ['/home', '/escalatedEventsUS', '/client-cameras', '/camera-combo-model-config']
};

// Always reachable so error/auth flows keep working for restricted clients.
const ALWAYS_ALLOWED_PAGES = ['/404', '/login', '/signin', '/auto-login'];

const normalizePath = (path) => {
  if (!path) return '';
  const trimmed = String(path).trim();
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const getRestrictedPages = (clientId) => RESTRICTED_CLIENT_PAGES[Number(clientId)] || null;

export const isClientRestricted = (clientId) => !!getRestrictedPages(clientId);

// Landing page for a restricted client: the first page it is allowed to open.
export const getRestrictedLandingPage = (clientId) => {
  const pages = getRestrictedPages(clientId);
  return pages ? pages[0] : '/';
};

export const isPageAllowedForClient = (clientId, path) => {
  const pages = getRestrictedPages(clientId);
  if (!pages) return true;
  const normalized = normalizePath(path);
  return pages.includes(normalized) || ALWAYS_ALLOWED_PAGES.includes(normalized);
};

export default RESTRICTED_CLIENT_PAGES;
